import React, { useEffect } from 'react';
import CloseModal from './containers/CloseModalContainer';
import ConfirmationModal from './containers/ConfirmationModal';
import Page from './containers/PageContainer';
import Header from './containers/HeaderContainer';
import Footer from './components/shared/Footer/Footer';

import './styles/app.scss';

const App = () => (
  <main className="claim-refund-container honeycomb">
    <CloseModal />
    <ConfirmationModal />
    <Header />
    <Page />
    <Footer />
  </main>
);

export default App;
